import type { FC } from 'react';
import { Animation } from '../Animation/animation.component';
import { StyledContainer } from './fallback.styles';

export const Fallback: FC = () => {
  return (
    <StyledContainer>
      <Animation />
    </StyledContainer>
  );
};
